module.exports = __webpack_public_path__ + "static/dash-234086a488be7f8e9cfa3a702ca979a0.svg";